(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.YeniSizeDiagnosis = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  var BANDS = [
    { max: 67.5, label: '65' },
    { max: 72.5, label: '70' },
    { max: 82.5, label: '75-80' },
    { max: Infinity, label: '85-90' }
  ];

  var CUPS = [
    { max: 13.75, label: 'AB' },
    { max: 18.75, label: 'CD' },
    { max: 23.75, label: 'EF' },
    { max: 28.75, label: 'GH' },
    { max: Infinity, label: 'IJ' }
  ];

  // 2026-09-17時点の販売サイズ（tasks/research-size-diagnosis.md §2-2）。
  // variant が変更されたら要更新。
  var AVAILABLE = [
    'AB/65', 'CD/65', 'EF/65', 'GH/65', 'IJ/65',
    'AB/70', 'CD/70', 'EF/70', 'GH/70', 'IJ/70',
    'AB/75-80', 'CD/75-80', 'EF/75-80', 'GH/75-80', 'IJ/75-80',
    'CD/85-90', 'EF/85-90', 'GH/85-90'
  ];

  var FALLBACK = { 'AB/85-90': 'CD/85-90', 'IJ/85-90': 'GH/85-90' };

  var OLD_UNDER = { S: '65', M: '70', L: '75-80', LL: '85-90' };
  var OLD_CUP = { '1': 'AB', '2': 'CD', '3': 'EF', '4': 'GH', '5': 'IJ' };

  var RANGE = { under: [55, 110], top: [55, 130] };

  function pick(list, v) {
    for (var i = 0; i < list.length; i++) {
      if (v < list[i].max) { return list[i].label; }
    }
    return list[list.length - 1].label;
  }

  function resolve(cup, band) {
    var size = cup + '/' + band;
    if (AVAILABLE.indexOf(size) !== -1) {
      return { requested: size, display: size, fallback: null, consult: false };
    }
    var fb = FALLBACK[size] || null;
    return { requested: size, display: fb, fallback: fb, consult: true };
  }

  function inRange(v, r) {
    return isFinite(v) && v >= r[0] && v <= r[1];
  }

  function diagnose(under, top) {
    under = Number(under);
    top = Number(top);
    if (!inRange(under, RANGE.under) || !inRange(top, RANGE.top)) {
      return { error: 'out_of_range' };
    }
    if (top <= under) { return { error: 'top_le_under' }; }
    return resolve(pick(CUPS, top - under), pick(BANDS, under));
  }

  function fromOldSize(old) {
    var m = /^([A-Za-z]+)([0-9])$/.exec(String(old == null ? '' : old).trim());
    if (!m) { return { error: 'invalid' }; }
    var band = OLD_UNDER[m[1].toUpperCase()];
    var cup = OLD_CUP[m[2]];
    if (!band || !cup) { return { error: 'invalid' }; }
    return resolve(cup, band);
  }

  return {
    BANDS: BANDS,
    CUPS: CUPS,
    AVAILABLE: AVAILABLE,
    FALLBACK: FALLBACK,
    RANGE: RANGE,
    pick: pick,
    resolve: resolve,
    diagnose: diagnose,
    fromOldSize: fromOldSize
  };
}));

if (typeof jQuery !== 'undefined') {
  jQuery(function ($) {
    var $root = $('[data-size-diagnosis]');
    if (!$root.length) { return; }

    var api = window.YeniSizeDiagnosis;
    var $result = $root.find('[data-sd-result]');

    function show(html) {
      $result.html(html);
      $result.attr('data-sd-state', 'shown');
    }

    function render(res) {
      if (!res || res.error) {
        var msg = res && res.error === 'top_le_under'
          ? 'トップバストはアンダーバストより大きい値を入力してください。'
          : 'アンダー55〜110cm・トップ55〜130cmの範囲で入力してください。';
        show('<p class="sd-result__error">' + msg + '</p>');
        return;
      }
      var html = '<p class="sd-result__label">あなたにおすすめのサイズ</p>' +
        '<p class="sd-result__size">' + res.display + '</p>';
      if (res.consult) {
        html += '<p class="sd-result__note">より近いサイズは、チャットでご相談ください。</p>';
      }
      show(html);
    }

    $root.on('click', '[data-sd-run]', function () {
      render(api.diagnose($root.find('[data-sd-under]').val(), $root.find('[data-sd-top]').val()));
    });

    $root.on('change', '[data-sd-old]', function () {
      var v = $(this).val();
      if (v) { render(api.fromOldSize(v)); }
    });
  });
}